import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as pagesActions from "../../actions/pagesActions";

const createPageSuccess = createLogic({
	type: ActionTypes.CREATE_PAGE_SUCCESS,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(pagesActions.loadPages(action.expId));
		done();
	},
});

export default [createPageSuccess];
